// extracted by mini-css-extract-plugin
module.exports = {"side_menu":"PersistentSideMenu_side_menu__rrE7_","hides_side_menu":"PersistentSideMenu_hides_side_menu__QkOkx"};